'use client';

import { useEffect, useState } from 'react';
import { useIsDesktop } from '@provider-directory/hooks/useBreakpoints';

/**
 * Desktop flag that stays stable through hydration: the server render assumes
 * desktop, then the real viewport takes over once mounted.
 */
export const useHydratedDesktop = (): boolean => {
  const [isMounted, setIsMounted] = useState(false);
  const isDesktopQuery = useIsDesktop();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      setIsDesktop(window.innerWidth >= 1024);
    } else {
      setIsDesktop(true);
    }
  }, [isMounted]);

  useEffect(() => {
    setIsDesktop(isDesktopQuery);
  }, [isDesktopQuery]);

  return isDesktop;
};
